import { useEffect } from 'react';
export const useScrollReset = ({ ref, optionsAreOpen }) => {
    useEffect(() => {
        if (optionsAreOpen && ref.current != null) {
            ref.current.scrollTop = 0;
        }
    }, [ref, optionsAreOpen]);
};
